import {
    STORE_DATA
} from '../../actions'
import keyBy from 'lodash/keyBy'
import omit from 'lodash/omit'

const initialState = {}

const data = (state = initialState, action) => {
    switch (action.type) {
        case STORE_DATA:
            if(Array.isArray(action.payload.data))
            {
                return {
                    ...state,
                    [action.payload.key]: {
                        ...state[action.payload.key],
                        ...keyBy(action.payload.data, 'id')
                    }
                }
            }
            else if(action.payload.data.items)
            {
                return {
                    ...state,
                    [action.payload.key]: {
                        ...state[action.payload.key],
                        params: omit(action.payload.data, ['items']),
                        ...keyBy(action.payload.data.items, 'id')
                    }
                }
            }
            else {
                return {
                    ...state,
                    [action.payload.key]: {
                        ...state[action.payload.key],
                        [action.payload.data.id]: action.payload.data
                    }
                }
            }
        default:
            return state
    }
}

export default data



// WEBPACK FOOTER //
// ./src/reducers/data/data.js